// extracted by mini-css-extract-plugin
export default {"node":"TranslationAlternativeRichText_node__lQmCD"};